import { render, staticRenderFns } from "./FormNewMail.vue?vue&type=template&id=7ff65962"
import script from "./FormNewMail.vue?vue&type=script&lang=js"
export * from "./FormNewMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports